import { observer } from 'mobx-react-lite'
import { JobProgressionMessageContent } from '@/features/messaging/components/ConversationView/Messages/List/JobProgressionMessageContent'
import { type JobProgressionMessageContentViewModel } from '@/features/messaging/JobProgressionMessageContentViewModel'

export interface JobProgressionMessageContentContainerProps {
  vm: JobProgressionMessageContentViewModel
}

export const JobProgressionMessageContentContainer = observer(
  function JobProgressionMessageContentContainer({
    vm,
  }: JobProgressionMessageContentContainerProps) {
    if (!vm.progressionStep) {
      return null
    }

    return (
      <JobProgressionMessageContent
        title={vm.title}
        description={vm.description}
        canAnswerDraftInReview={vm.canAnswerDraftInReviewMessage}
        hasResponse={vm.hasResponse}
        onViewApproveDraft={vm.onViewApproveDraft}
        onViewRejectDraft={vm.onViewRejectDraft}
      />
    )
  },
)
